import { SsoSdk } from "sso-frontend-sdk";

let sso: SsoSdk | null = null;

export function getSsoInstance() {
//   console.log('getSsoInstance')
  if (typeof window === "undefined") return null;
  if (!sso) {
    sso = new SsoSdk({
      baseUrl: process.env.NEXT_PUBLIC_SSO_BASE_URL,
      debug: false,
      tokenStorageType: "localStorage",
      autoRefreshToken: true,
    });
  }
  return sso;
}
